/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithoutCode } from './BaseCouponWithoutCode';
import { TenantAccessPlan } from './TenantAccessPlan';
const AccessPassCouponWithoutCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['plan', TenantAccessPlan],
]), BaseCouponWithoutCode);
export class AccessPassCouponWithoutCode extends BaseCouponWithoutCode {
    static decode(input) {
        return AccessPassCouponWithoutCodeParser.decode(input).map(res => new AccessPassCouponWithoutCode(res));
    }
    static unsafeDecode(input) {
        return AccessPassCouponWithoutCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessPassCouponWithoutCodeParser.encode(data);
    }
    static schema() {
        return AccessPassCouponWithoutCodeParser.schema();
    }
}
